import React from 'react';

const OpenInNewLink = props => {
  return <a href={props.href}
            target="_blank"
            rel="noopener noreferrer">
    {props.children} <span className="align-middle material-icons" style={{fontSize: '1.2rem'}}>open_in_new</span>
  </a>;
};

export default OpenInNewLink;
